// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "app_static/" + chunkId + ".bundle." + {"359":"dd98385f47d01e5761fa","998":"de167238df864874a762"}[chunkId] + ".js";
};